import { extractApiError } from '../models';

export function apiErrorMessage(error: unknown, fallback: string): string {
  const apiError = extractApiError((error as { error?: unknown } | null)?.error);
  if (apiError?.code === 'validation_failed' && apiError.details) {
    return Object.values(apiError.details).flat().join(' ');
  }
  return apiError?.message || fallback;
}
